import { UpperCasePipe } from '@angular/common';
import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { MessageService } from '../../shared/services/message.service';
import { ViewerService } from '../link-service.service';

@Component({
	selector: 'iishapes-password-dialog',
	templateUrl: './password-dialog.component.html',
	styleUrls: ['./password-dialog.component.sass'],
	providers: [UpperCasePipe],
	encapsulation: ViewEncapsulation.None

})
export class IIShapesPasswordDialogComponent {
	buttonAccept = this.translateService.instant('COMMON.ACCEPT');
	buttonCancel = this.translateService.instant('COMMON.CANCEL');
	title = '';
	messageText = '';
	editMessageForm: UntypedFormGroup;

	isPasswordInvalid: boolean = false;
	public designViewerId: string | undefined;

	constructor(private fb: UntypedFormBuilder,
		private viewerService: ViewerService,
		private messageService: MessageService,
		public thisDialogRef: MatDialogRef<IIShapesPasswordDialogComponent>,
		private translateService: TranslateService,
		@Inject(MAT_DIALOG_DATA) public data: any) {


		if (data.buttonAccept) {
			this.buttonAccept = data.buttonAccept;
		}
		if (data.buttonCancel) {
			this.buttonCancel = data.buttonCancel;
		}

		this.designViewerId = data['designViewerId'];

		// this.translateService.getTranslation(data.title).subscribe(r => {
		// 	this.title = r;
		// });
		if (data.message !== null && data.message !== undefined && data.message !== '') {
			this.translateService.get(data.message).subscribe(r => {
				this.messageText = r;
			});
		}

		this.editMessageForm = this.fb.group({
			message: [this.messageText, [Validators.required]]
		});
	}

	onSubmit() {
		const password = this.editMessageForm.get('message').value;

		this.viewerService.getViewerDesignValidatesPassword(this.designViewerId, password).subscribe(
			res => {

				if (res == true) {
					this.thisDialogRef.close(password);
				}
				else {
					this.messageService.showErrorMessage("Oops, that password doesn’t seem to be correct. Could you try again?");
				}
			}
		)
	}

	onCloseCancel() {
		this.thisDialogRef.close(null);
	}

}
